import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: 'http://localhost:4100/api',
  baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'cedu-app': JSON.stringify({
      name: 'cedu-front',
      version: 'unknown',
    }),
    Pragma: 'no-cache',
  },
  withCredentials: true, // 쿠키 허용
  validateStatus: status => (status >= 200 && status < 300) || status === 401
});

// axiosInstance.interceptors.request.use(config => {
//   const token = localStorage.getItem('token');
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

let isRedirecting = false;

// 401 에러 - 쎄듀북 로그인 페이지로 이동
axiosInstance.interceptors.response.use(
  response => {

    if (!isRedirecting) {
      if (response.status === 401) {
        alert('통합 로그인 후 사용 가능합니다.');
        isRedirecting = true;
        window.location.href = 'https://www.cedubook.com/login';
        return Promise.reject(response);
      }
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
